import React, { useEffect } from "react";
import WhatWeDo from "./WhatWeDo";
import MakeAnImpact from "./MakeAnImpact";
import AOS from "aos";
import "aos/dist/aos.css";
import "./News.css";

const News = () => {
  useEffect(() => {
    AOS.init({ 
      duration: 1200,
      once: true,
      easing: 'ease-out-cubic'
    });
  }, []);

  return (
    <div>
      <h1 className="news" data-aos="fade-down">
        <span className="news-title-text">Latest News & Updates</span>
      </h1>
      <MakeAnImpact />
      <hr />
      <WhatWeDo />
    </div>
  );
}

export default News;